<template>
    <div class="account">
        <div class="title">
            <el-breadcrumb >
                <el-breadcrumb-item>账户信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="main">
            <el-button v-show="activeName == 'warehouse'" type="primary" size="medium" class="create" @click="createWarehouse('add')">添加</el-button>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="基本信息" name="info" :class="activeName == 'info' ? 'marginUn' : ''">
                    <info />
                </el-tab-pane>
                <el-tab-pane label="修改密码" name="pwd">
                    <pass />
                </el-tab-pane>
                <el-tab-pane label="协议管理" name="man">
                    <div style="margin: 40px">
                        <div class="man">
                            <el-checkbox v-model="read" class="check"></el-checkbox>
                            <p>
                                我已阅读并同意
                                <span @click="dialogVisible2 = true">《九不欺开放平台入驻协议》</span>
                                <span @click="dialogVisible = true">《九不欺隐私政策》</span>
                            </p>
                        </div>
                        <el-button type="primary" style="margin-top: 22px" @click="changeAccept">确定签署协议</el-button>
                    </div>
                </el-tab-pane>
                <!-- <el-tab-pane label="仓库管理" name="warehouse">
                    <warehouse ref="refWarehouse" @edit="edit" @detail="detail"/>
                </el-tab-pane> -->
            </el-tabs>
        </div>
        <CreateOrEdit ref="refCreateOrEdit" @init="getList(1)"></CreateOrEdit>
        <Detail ref="refDetail"></Detail>

        <el-dialog title="九不欺开放平台入驻协议" center :visible.sync="dialogVisible2" width="70%">
            <page1 />
            <span slot="footer" class="dialog-footer">
                <a class="man" href="https://static.xinfushenghuo.cn/publics/imgs/updatas/20220124/九不欺公约及入驻协议.pdf" target="_blank" rel="noopener noreferrer">
                    点击下载：《九不欺公约及入驻协议》</a
                >
                <el-button
                    type="primary"
                    @click="
                        dialogVisible = false;
                        read = true;
                    "
                    >确 定</el-button
                >
            </span>
        </el-dialog>
        <el-dialog title="九不欺隐私政策" center :visible.sync="dialogVisible" width="70%">
            <page />
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    @click="
                        dialogVisible = false;
                        read = true;
                    "
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import info from "./component/info";
import pass from "./component/pass";
import warehouse from "./component/warehouse";
import CreateOrEdit from "./component/createOrEdit";
import Detail from "./component/detail";
import page from "./component/page";
import page1 from "./component/page1";
export default {
    data() {
        return {
            activeName: "info",
            read: false,
            dialogVisible: false,
            dialogVisible2: false,
        };
    },
    components: {
        info,
        pass,
        warehouse,
        CreateOrEdit,
        Detail,
        page,
        page1,
    },
    computed: {
        ...mapGetters({
            getToken: "getToken",
            getUserInfo: "getUserInfo",
        }),
    },
    created() {
      if (this.getUserInfo.is_accept_convention) {
         this.read = this.getUserInfo.is_accept_convention == 1;
      }
       
    },
    methods: {
        ...mapActions({
            updateAccept: "detect/updateAccept",
        }),
        changeAccept() {
            if (!this.read) {
                return this.$message.warning("请先同意签署协议");
            }
            let params = {
                is_accept_convention: 1,
                token: this.getToken,
            };
            this.updateAccept(params).then(({data}) => {
                console.log(data);
                if (data.code == 1) {
                    this.$message.success("已签署九不欺公约及入驻协议");
                }else{
                    this.$message.error(data.msg);

                }
            });
        },
        handleClick(tab, event) {},
        createWarehouse(type) {
            this.$refs.refCreateOrEdit.dialogVisible = true;
        },
        getList(tag) {
            this.$refs.refWarehouse.getList(1);
        },
        detail(id) {
            this.$refs.refDetail.dialogVisible = true;
            this.$nextTick(() => {
                this.$refs.refDetail.getDetail(id);
            });
        },
        edit(row) {
            this.$refs.refCreateOrEdit.dialogVisible = true;
            this.$nextTick(() => {
                this.$refs.refCreateOrEdit.bindData(row);
            });
        },
    },
};
</script>
<style lang='scss' scoped>
.check {
    margin-right: 4px;
    margin-top: 2px;
}

.check .el-checkbox__inner {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #e72f0d;
    border-color: #e72f0d !important;
}

.check .el-checkbox__input.is-checked .el-checkbox__inner::after {
    transform: rotate(45deg) scaleY(1.3);
}

.check .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #e72f0d;
    background: #e72f0d;
}

.check .el-checkbox__inner::after {
    height: 8px;
    left: 7px;
    top: 4px;
}
.agreement p {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333330;
    line-height: 20px;
    margin-left: 10px;
}

.agreement p span {
    color: #e72f0d;
    cursor: pointer;
}

.title {
    width: 100%;
    background: #fff;
    font-size: 20px;
    color: #000000;
    width: 100%;
    padding: 15px 32px;
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
}
.main {
    min-height: 760px;
    box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
    background: #fff;
    margin: 24px;
    padding: 20px;
    padding-bottom: 70px;
    min-width: 1200px;
}

.marginUn {
    .info {
        margin: unset !important;
    }
}
.main {
    position: relative;
    .create {
        position: absolute;
        right: 20px;
        top: 12px;
        z-index: 1;
    }
}

.man {
    display: flex;
    margin-top: 22px;
    span {
        margin-right: 0;
        color: red;
        &:hover {
            color: #0094ff;
        }
    }
}
</style>